import Poll from "./components/poll";

export interface IApp {
  id: number,
  type: string,
  app_id?: number|string // Legacy
}

const App = ({id, type}: IApp) => {
  
  return <>
    {type === "poll" && <Poll id={id} type={type}/>}
  </>
}


export default App;

